import { FC } from 'react';

import {
  Progress,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import classes from './FloorMap.module.scss';

export const FloorMapLoading: FC = () => {
  return (
    <div
      className={clsx(classes.container, classes.border, classes.center)}
      data-testid='floorMapLoading'
    >
      <div className={classes.progressContainer}>
        <Typography>Загрузка плана</Typography>
        <Progress type='solo' cycled data-testid='floorMapLoadingProgress' />
      </div>
    </div>
  );
};
